import { gql } from '__generated__'

export const CreateImpersonationCode = gql(/* GraphQL */ `
    mutation CreateImpersonationCode($targetUserId: ID!, $targetRole: String!) {
        createImpersonationCode(
            targetUserId: $targetUserId
            targetRole: $targetRole
        ) {
            code
            redirectUrl
        }
    }
`)
